import styled from 'styled-components';

import { mobileFirstBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BlockContainer } from '@r1-frontend/ui-react/experimental/containers';

export const Stats = styled(BlockContainer)`
    width: 100%;
    margin-bottom: 32px;

    @media (min-width: ${mobileFirstBreakpoints.mobile}) {
        margin-bottom: 64px;
    }
`;

export const ListItem = styled.li`
    width: 100%;
      
    @media (min-width: ${mobileFirstBreakpoints.mobile}) {
        width: 308px;  
    }
    
    @media (min-width: ${mobileFirstBreakpoints.laptop}) {
        width: calc(50% - 16px);  
    }
    
    @media (min-width: ${mobileFirstBreakpoints.sDesktop}) {
        width: 330px;  
    }
`;
